/**
 * Author: marco
 * Last updated: 2025-05-30
 */

// Global test setup
beforeAll(() => {
	// Setup environment variables for testing
	if (!process.env.NODE_ENV) {
		Object.defineProperty(process.env, 'NODE_ENV', {
			value: 'test',
			writable: true,
		});
	}
});

afterAll(() => {
	// Cleanup after all tests
});

// Mock N8N core modules
jest.mock('n8n-workflow', () => ({
	NodeApiError: class NodeApiError extends Error {
		constructor(_node: any, error: any, _options?: any) {
			super(error.message || 'API Error');
			this.name = 'NodeApiError';
		}
	},
	NodeOperationError: class NodeOperationError extends Error {
		constructor(_node: any, error: any, _options?: any) {
			super(error.message || 'Operation Error');
			this.name = 'NodeOperationError';
		}
	},
}));

jest.mock('n8n-core', () => ({
	// Add mock implementations as needed
}));
